import { render } from "./DashboardSelector.vue?vue&type=template&id=0a8273c5&scoped=true"
import script from "./DashboardSelector.vue?vue&type=script&lang=js"
export * from "./DashboardSelector.vue?vue&type=script&lang=js"

import "./DashboardSelector.vue?vue&type=style&index=0&id=0a8273c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8273c5"]])

export default __exports__